/**
 * Sample Database constants (first-run "Explore a sample database" flow).
 *
 * The bundled Chinook SQLite file opens as a normal local read-write
 * connection with a stable id, so re-opening reconnects instead of
 * duplicating and the connection persists like any other.
 */

export const SAMPLE_DB_CONNECTION_ID = 'sample-chinook';

export const SAMPLE_DB_ALIAS = 'Chinook (sample)';

/**
 * The query pre-filled (and auto-executed) in the landing tab. Deliberately a
 * multi-table join with aggregates — "this tool handles real SQL", not
 * SELECT 1. The comment header doubles as the bridge back to "add your own
 * connection".
 */
export const SAMPLE_DB_SHOWCASE_QUERY = `-- Welcome to Jam SQL Studio! This is Chinook, a sample music store.
-- It's a real local SQLite database — edit anything, you can't break it.
-- Ready for your own data? Click "+" in the Explorer to add a connection.
SELECT ar.Name AS Artist, COUNT(DISTINCT al.AlbumId) AS Albums,
       ROUND(SUM(il.UnitPrice * il.Quantity), 2) AS Revenue
FROM InvoiceLine il
JOIN Track t  ON t.TrackId = il.TrackId
JOIN Album al ON al.AlbumId = t.AlbumId
JOIN Artist ar ON ar.ArtistId = al.ArtistId
GROUP BY ar.ArtistId
ORDER BY Revenue DESC
LIMIT 10;
`;
